function ifNotTrueExecute(value: boolean, callback: () => void): void {
  if (!value) {
    callback()
  }
}

export default ifNotTrueExecute
